import React from 'react';
import { Text } from 'rizzui';
import CustomModal from '../../../components/modal/CustomModal';

interface ConfirmRemittancesModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    selectedCount: number;
    isLoading?: boolean;
}

const ConfirmRemittancesModal: React.FC<ConfirmRemittancesModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    selectedCount,
    isLoading = false,
}) => {
    const isSingle = selectedCount === 1;

    return (
        <CustomModal
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={onConfirm}
            name={isSingle ? 'Confirmar remesa' : 'Confirmar remesas'}
            confirmText='Confirmar'
            cancelText='Cancelar'
            size='md'
            isLoading={isLoading}
        >
            <Text className="text-gray-600">
                {isSingle
                    ? '¿Estás seguro de confirmar esta remesa (una vez confirmada no podrá ser cancelada)?'
                    : `¿Estás seguro de confirmar las ${selectedCount} remesas seleccionadas (una vez confirmadas no podrán ser canceladas)?`}
            </Text>
        </CustomModal>
    );
};

export default ConfirmRemittancesModal;
